const white = '#ffffff';
const black = '#000000';
const gray = '#f1f1f1';
const warningColor = 'red';

const bright = {
  background: {
    primary: white,
    contextMenu: gray,
  },
  font: {
    primary: black,
    warning: warningColor,
  },
  navigation: {
    background: 'rgba(255, 253, 250, 0.96)',
    surface: '#fffdfa',
    raisedSurface: '#edf4f3',
    border: '#dbe2e1',
    divider: '#edf1f0',
    text: '#405255',
    mutedText: '#315052',
    heading: '#152f31',
    activeBackground: '#dff2ef',
    activeText: '#0c5d5c',
    tabActiveBackground: '#0c7772',
    tabActiveText: white,
    accent: '#0c7772',
    focus: '#1c948e',
    handle: '#c6d1d0',
    scrim: 'rgba(10, 28, 31, 0.42)',
    shadow: 'rgba(13, 37, 40, 0.08)',
    raisedShadow: 'rgba(10, 28, 31, 0.22)',
    headerShadow: 'rgba(0, 0, 0, 0.3)',
  },
};

const dark = {
  background: {
    primary: '#1B1C1D',
    contextMenu: '#252627',
  },
  font: {
    primary: 'rgba(240, 240, 240, 1)',
    warning: warningColor,
  },
  navigation: {
    background: 'rgba(27, 28, 29, 0.96)',
    surface: '#252627',
    raisedSurface: '#2f3031',
    border: '#3b4545',
    divider: '#3b4545',
    text: '#b8d3cf',
    mutedText: '#b8d3cf',
    heading: '#f0f0f0',
    activeBackground: '#245d5c',
    activeText: white,
    tabActiveBackground: '#245d5c',
    tabActiveText: white,
    accent: '#7ad7ca',
    focus: '#7ad7ca',
    handle: '#62706f',
    scrim: 'rgba(10, 28, 31, 0.62)',
    shadow: 'rgba(0, 0, 0, 0.32)',
    raisedShadow: 'rgba(0, 0, 0, 0.48)',
    headerShadow: 'rgba(0, 0, 0, 0.55)',
  },
};

const themes = {
  bright,
  dark,
};

export const getTheme = theme => themes[theme] || bright;
